import React from "react";
import { Component } from "react";
import UserService from "../../services/UserService";
import { number } from "yup";

interface Comment {
  id: number,
  jobId: number,
  userId: number,
  comment: string,
  createdAt: string,
  updatedAt: string,
  deletedAt: string
}

type Props = {};

type State = {
  comments: Comment[];
}

export default class ViewHome extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      comments: []
    };
  }

  componentDidMount() {
    UserService.getAllComments().then(
      response => {
        this.setState({
          comments: response.data
        });
      },
      error => {
        this.setState({
          comments:
            (error.response && error.response.data) ||
            error.message ||
            error.toString()
        });
      }
    );
  }

  render() {
    let listItems :[] = [];
    if (Array.isArray(this.state.comments) && this.state.comments.length)  {
      this.state.comments.forEach((d) =>
        <><p key={d.id}>{d.comment}</p>
          <p>{d.userId}</p>
          <p>Created at: {d.createdAt}</p></>
      );
    } else {
      <>
        listItems.push(<p key="no-comments">"No comments found."</p>)
      </>
    }
    return (
      <div className="container">
        <h1>User comments</h1>
        <header className="jumbotron">
          <h6>{listItems}</h6>
        </header>
      </div>
    );
  }
}